import { render, staticRenderFns } from "./about-me.vue?vue&type=template&id=b559bde4&scoped=true"
import script from "./about-me.vue?vue&type=script&lang=js"
export * from "./about-me.vue?vue&type=script&lang=js"
import style0 from "./about-me.vue?vue&type=style&index=0&id=b559bde4&prod&lang=scss&scoped=true"
import style1 from "./about-me.vue?vue&type=style&index=1&id=b559bde4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b559bde4",
  null
  
)

export default component.exports